import type { ZodIssue } from "zod";

export const formatZodIssue = (issue: ZodIssue): string => {
  const path = issue.path.length === 0 ? "value" : issue.path.join(".");
  return path + ": " + issue.message;
};

export const formatZodIssues = (issues: readonly ZodIssue[]): string =>
  issues.map(formatZodIssue).join("; ");
